import { memo, useState } from 'react';
import { Alert, Snackbar, Typography } from '@mui/material';

const Error = props => {
  const [openAlert, setOpenAlert] = useState(true);
  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenAlert(false);
  };
  return (
    <Snackbar
      open={openAlert}
      autoHideDuration={5000}
      onClose={handleCloseAlert}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={handleCloseAlert} severity="error" sx={{ width: '100%' }}>
        <Typography variant="subtitle1">
          Ocorreu um erro.
          <br />
          {props && props.erro ? props.erro : ''}
          Ocorreu um erro no servidor, favor entrar em contato com o suporte.
        </Typography>
      </Alert>
    </Snackbar>
  );
};
export default memo(Error);
